<template>
    <div>
        <div v-if="!isLoading" class="payment-wrapper">
            <div id="checkout-container"></div>
        </div>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </div>
</template>

<script>
import AxiosClient from "@/app/shared/services/http-client/axios";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

const availableLocales = ["cs", "de", "en", "es", "fr", "hu", "it", "ko", "lv", "pl", "ru", "uk"];
const locale = availableLocales.includes(process.env.VUE_APP_LOCALE)
    ? process.env.VUE_APP_LOCALE
    : "en";

export default {
    name: "FondyOrder",
    props: ["userId", "onSuccess", "onDecline", "onCancel"],
    components: { OverlayLoader },
    data() {
        return {
            isLoading: false,
            formData: {},
            paymentUrl: undefined,
            endpoints: {},
            Options: {
                options: {
                    methods: ["card"],
                    methods_disabled: ["banklinks_eu", "wallets", "local_methods"],
                    card_icons: ["mastercard", "visa", "maestro"],
                    active_tab: "card",
                    fields: false,
                    full_screen: false,
                    button: true,
                    locales: [locale],
                    email: false,
                    title: "* " + this.$t("pay.commission"),
                },
                params: {
                    token: null,
                },
                messages: {
                    ru: {
                        pay: this.$t("continue"),
                    },
                    es: {
                        pay: this.$t("continue"),
                    },
                    en: {
                        pay: this.$t("continue"),
                    },
                },
            },
            fondy: null,
        };
    },
    mounted() {
        var _this = this;
        this.newPayment().then((data) => {
            this.fondy = fondy("#checkout-container", this.Options)
                .$on("success", function (model) {
                    _this.onSuccess();
                })
                .$on("error", function (model) {
                    _this.onDecline();
                });
        });
    },
    beforeDestroy() {
        this.fondy.$destroy();
    },
    methods: {
        newPayment() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;
                AxiosClient.get("/payment/payment-token", {
                    params: { user_id: this.userId },
                })
                    .then((response) => {
                        this.paymentUrl = response.data.url;
                        this.endpoints = this.reverseObject(response.data.endpoints);
                        this.Options.params.token = response.data.token;
                        this.isLoading = false;
                        resolve(response.data.url);
                    })
                    .catch(() => reject())
                    .finally(() => (this.isLoading = false));
            });
        },
        reverseObject(obj) {
            const reversed = {};
            Object.keys(obj).forEach((key) => {
                reversed[obj[key]] = key;
            });
            return reversed;
        },
    },
};
</script>

<style>
.payment-wrapper {
    max-width: 450px;
    margin: 0 auto;
}

.f-modal-dialog {
    display: none !important;
}

.f-button-pay span {
    display: none !important;
}

.f-button-pay span:first-child {
    display: inline !important;
}

.f-merchant-name {
    font-size: 9px;
}

.f-order-desc {
    display: none !important;
}

.f-payment-method-card-inner {
    padding-top: 30px;
}
</style>
